import Vue from 'vue'
import Vuex from 'vuex'
import Router from 'vue-router'
import Vuetify from 'vuetify'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import notification from './modules/notification'
import loading from './modules/loading'
import auth from './modules/auth'
import admin from './modules/admin'
import stripe from './modules/stripe'
import localStoragePlugin from './plugins/localStorage'

Vue.use(Vuex)
Vue.use(Router)
Vue.use(Vuetify)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    roles: [],
    plans: [],
    organizations: [],
    userOrganization: null,
    selectedOrganizationId: null,
    selectedProjectId: null,
    projectsDisplay: 'normal',
    displayOwnProjects: false,
    projectCategories: ['arts', 'sciences', 'personality', 'technology', 'crisis', 'world crisis', 'current event', 'feminism', 'geographical', 'humanitarian', 'mainstream', 'political', 'refugees', 'sports', 'nature', 'social issue'],
    statuses: ['Active', 'Archived', 'Disabled', 'Deactivated', 'Draft', 'Pending Organization Approval', 'Pending External Approval', 'Active (Pending Changes Approval)', 'Pending User Approval'],
    categorySymbols: ['fas fa-landmark', 'fas fa-globe-americas', 'fas fa-venus', 'fas fa-palette', 'fas fa-hands-helping', 'fas fa-fire', 'fas fa-users', 'fas fa-suitcase'],
    loginState: 'closed',
    requestedProjects: [],
    newUserUuid: null,
    breadcrumbs: null
  },
  actions,
  getters,
  mutations,
  modules: { notification, loading, auth, admin, stripe },
  plugins: [localStoragePlugin],
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js